<template>
  <div id="projects-slide">
    <div class="slider-draggable noselect">
      <div class="slider-draggable__scroll">
        <div
          class="slider-draggable__col smooth-shadow"
          v-for="(project, i) in items"
          :key="project.name + i"
          :style="`background-image: url(${project.cover || project.image})`"
        >
          <div class="slider-draggable__col__content">
            <h2 class="text-uppercase font-weight-bold">{{ project.name }}</h2>
            <button
              class="btn btn-light rounded-0 px-4 shadow"
              @click="$router.push(`/proyecto/${project.id}`)"
            >
              Ver proyecto
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScrollBooster from "scrollbooster";

export default {
  name: "ProjectsSlide",
  props: {
    items: Array
  },
  data() {
    return {
      //
    };
  },
  mounted: function () {
    const slider = document.querySelector(".slider-draggable");
    const sliderScroll = document.querySelector(".slider-draggable__scroll");

    new ScrollBooster({
      viewport: slider,
      content: sliderScroll,
      direction: "horizontal",
      scrollMode: "native",
      bounceForce: 0.5,
      // onUpdate: (data) => {
      //   // eslint-disable-next-line
      //   sliderScroll.scrollLeft = data.position.x
      // }
      // onClick: data => {
      //   data.target.focus();
      // }
    });

    // MOUSE EVENTS
    slider.addEventListener("mousedown", () => {
      slider.classList.add("active");
    });
    slider.addEventListener("mouseup", () => {
      slider.classList.remove("active");
    });

    // TOUCH EVENTS
    slider.addEventListener("touchstart", (e) => {
      e.target.classList.toggle("active");
    });
    slider.addEventListener("touchend", () => {
      slider.classList.remove("active");
    });
    slider.addEventListener("touchcancel", (e) => {
      slider.classList.remove("active");
      e.target.classList.remove("active");
    });
    slider.addEventListener("touchmove", () => {
      slider.classList.add("active");
    });
  }
};
</script>

<style lang="sass">
#projects-slide
  min-height: 350px
  .slider-draggable
    width: 100vw
    height: 120%
    overflow: hidden
    position: absolute
    top: 0
    right: 0
    transform: translateX(109px)
    padding: 2rem 0 3rem
    &.active
      & > div
        & > div
          cursor: grabbing
          cursor: -webkit-grabbing
          transform: scale(1.05)
          box-shadow: 0 1rem 2rem 0 rgba(0, 0, 0, 0.07), 0 1rem 2rem -2rem rgba(0, 0, 0, 0.15)
    &__scroll
      overflow-x: auto
      overflow-y: hidden
      /*-webkit-overflow-scrolling: touch*/
      display: flex
      flex-wrap: nowrap
      padding-bottom: 60px
    &__col
      width: 350px
      height: 350px
      flex: 0 0 auto
      background-position: center center
      background-size: cover
      background-repeat: no-repeat
      margin: 8px
      &:hover
        cursor: pointer
      &:first-child
        margin-left: 175px
      &__content
        padding: 1rem
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        height: 100%
        color: white
        opacity: 0
        transition: 0.5s ease
        background: linear-gradient(to top, rgba(129,137,121,1) 0%, rgba(213,219,208,0.25) 100%)
        &:hover, &.active
          opacity: 1
    .btn.btn-light
      background-color: #e2e6ea
      border: 0
      &:hover, &:active
        background-color: #f8f9fa

@media screen and (min-width: 1367px)
  #projects-slide
    .slider-draggable
      transform: translateX(386px)
@media screen and (max-width: 502px)
  #projects-slide
    .slider-draggable
      transform: translateX(0px)
      &__col
        &:first-child
          margin-left: -30px
</style>
